import { render, staticRenderFns } from "./viewNormalRecord.vue?vue&type=template&id=2fb0eb2a&scoped=true&"
import script from "./viewNormalRecord.vue?vue&type=script&lang=js&"
export * from "./viewNormalRecord.vue?vue&type=script&lang=js&"
import style0 from "./viewNormalRecord.vue?vue&type=style&index=0&id=2fb0eb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0eb2a",
  null
  
)

export default component.exports